import React, { useState } from 'react';
import { Badge, IconButton, Menu } from '@mui/material';
import PropTypes from 'prop-types';
import { BsMegaphone } from 'react-icons/bs';
import AppTooltip from '../AppTooltip';
import { alpha } from '@mui/material/styles';
import AppNotificationContent from './AppNotificationContent';
import { useSelector } from 'react-redux';

const AppNotifications2 = ({
  drawerPosition,
  tooltipPosition,
  isMenu,
  sxNotificationContentStyle,
}) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const showNotification = Boolean(anchorEl)

  const [notificationData] = useSelector(({ portal }) => [portal.notifications]);

  const handleClickNotification = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseNotification = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <AppTooltip title='Pusat Pemberitahuan' placement={tooltipPosition}>
        <Badge badgeContent={notificationData?.counter?.unread_count ?? 0} color='error' sx={{
          '& .MuiBadge-badge': {
            marginTop: '5px'
          }
        }}>
          <IconButton
            className='icon-btn'
            sx={{
              borderRadius: '50%',
              width: 40,
              height: 40,
              color: (theme) => theme.palette.text.secondary,
              backgroundColor: (theme) => theme.palette.background.default,
              border: 1,
              borderColor: 'transparent',
              '&:hover, &:focus': {
                color: (theme) => theme.palette.text.primary,
                backgroundColor: (theme) =>
                  alpha(theme.palette.background.default, 0.9),
                borderColor: (theme) =>
                  alpha(theme.palette.text.secondary, 0.25),
              },
            }}
            onClick={handleClickNotification}
            aria-controls={showNotification ? 'notification-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={showNotification ? 'true' : undefined}
            size='large'
          >
            <BsMegaphone />
          </IconButton>
        </Badge>
      </AppTooltip>

      <Menu
        anchorEl={anchorEl}
        id="notification-menu"
        open={showNotification}
        onClose={handleCloseNotification}
        // onClick={handleCloseNotification}
        PaperProps={{
          style: {
            width: 600,
            marginTop: 50,
            borderRadius: 8
          },
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
      >
        <AppNotificationContent
          sxStyle={sxNotificationContentStyle}
          onClose={handleCloseNotification}
        />
      </Menu>
    </>
  );
};

export default AppNotifications2;

AppNotifications2.defaultProps = {
  drawerPosition: 'right',
  tooltipPosition: 'bottom',
};

AppNotifications2.propTypes = {
  drawerPosition: PropTypes.string,
  tooltipPosition: PropTypes.string,
  isMenu: PropTypes.bool,
  sxNotificationContentStyle: PropTypes.object,
};
